import Appointment2 from '@/components/Appointment2';
import { SKILL_LIST } from './index.js';
import Skill from '@/components/Skill';
import { mapGetters, mapMutations } from 'vuex';
import Banner from './components/Banner/Banner.vue';
import { getInfo } from '@/api/modules/personal';
import Product from './components/Product';
import Technology from './components/Technology.vue';
import Solutions from './components/Solutions.vue';
import { fastContract } from '@/api/modules/product.js';
import Recommend from './components/Recommend';
import Partner from './components/Partner';
import { getCategoryByGroupType, getProduct } from '@/api/modules/product';
export default {
  components: {
    Appointment2,
    Banner,
    Product,
    Technology,
    Solutions,
    Skill,
    Recommend,
    Partner
  },
  data() {
    return {
      skillList: SKILL_LIST,
      productId: this.$productId.SHOU_YE,
      popoverVisible: false
    };
  },
  created() {
    this.handleComponent();
    if (this.haslogin) {
      this.getInfoData();
    }
  },
  computed: {
    ...mapGetters(['haslogin'])
  },
  methods: {
    ...mapMutations({
      setUseProduct: 'user/setUseProduct'
    }),
    // 获取个人信息
    async getInfoData() {
      await getInfo().then(res => {
        if (res.code === 1) {
          const {
            result
          } = res;
          // console.log(result,'pppp');
          if (result) {
            this.setUseProduct(result.presentation_permissions);
          }
        }
      });
    },
    async handleAppoint() {
      const h = this.$createElement;
      this.popoverVisible = false;
      if (this.haslogin) {
        fastContract({
          source: '官网',
          product_name: this.$route.meta.title
        }).then(res => {
          if (res.code === 1) {
            this.$success({
              title: '预约成功',
              content: h("div", [h("p", ["\u60A8\u7684\u7533\u8BF7\u5DF2\u63D0\u4EA4\uFF0C\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u548C\u60A8\u8054\u7CFB\uFF01"]), h("p", ["\u5982\u6709\u4EFB\u4F55\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BF9\u63A5\u7684\u540C\u82B1\u987A\u9500\u552E\u540C\u4E8B\u6216\u81F4\u75350571-88911818"])])
            });
          }
        });
      } else {
        this.$confirm({
          title: '您还没有登录，请点击前往登录',
          onOk: () => {
            this.$router.replace({
              path: '/login'
            });
          },
          centered: true
        });
      }
    },
    ...mapMutations({
      setList: 'app/setList'
    }),
    async handleComponent() {
      getCategoryByGroupType({
        group_type: 'component'
      }).then(async res => {
        if (res.code === 1) {
          var _res$result$;
          const activedIndex = (_res$result$ = res.result[0]) === null || _res$result$ === void 0 ? void 0 : _res$result$.group_code;
          await getProduct({
            group_code: activedIndex
          }).then(res1 => {
            if (res1.code === 1) {
              this.setList(res1.result[0]);
            }
          });
        }
      });
    }
  }
};